import React, { Fragment, useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import { Button, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, IconButton, InputLabel, Fab, Grid, InputAdornment, Paper, Select, TextField, CircularProgress } from '@material-ui/core';
import { Add, HighlightOffOutlined } from '@material-ui/icons';
import { useEffect } from 'react';
import { useData } from '../../../contexts/DataContext';
import { GridCellValue } from '@material-ui/data-grid';
import { DateTimePicker } from "@material-ui/pickers";
import LogsTable from '../../../app/components/datatables/LogsTable';
import Title from '../../../app/components/Title';
import UserPageStyles from '../UserPageStyles';
import { Alert, AlertTitle } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';

const UserRiverLevelLogs: React.FC = () => {
    const classes = UserPageStyles();
    const auth = useAuth();
    const [riverlevelReading, setRiverlevelReading] = React.useState(0.0);
    const [latitude, setLatitude] = React.useState(0.0);
    const [longitude, setLongitude] = React.useState(0.0);
    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const [address, setAddress] = React.useState('Not Available');
    const [watershedCode, setWatershedCode] = React.useState('Not Available');
    const [image, setImage] = React.useState<File>();
    const [riverlevelData, setRiverlevelData] = React.useState<any>([]);
    const [modalImage, setModalImage] = React.useState('');
    const [openImageModal, setOpenImageModal] = React.useState(false);
    const [imageUrlToDelete, setDeleteImageUrl] = React.useState('');
    const [docToDelete, setDocToDelete] = React.useState('');
    const [deleteModal, setDeleteModal] = React.useState(false);
    const [openAlert, setOpenAlert] = React.useState(false);
    const [alertSuccess, setAlertSuccess] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState('');
    const [alertMessageTitle, setAlertMessageTitle] = React.useState('');
    const [fileName, setFileName] = React.useState('');
    const [disableSubmit, setDisableSubmit] = React.useState(false);
    const [disableFab, setDisableFab] = React.useState(false);
    const [confirmationModal, setConfirmationModal] = React.useState(false);
    const [scaleName, setScaleName] = React.useState('');
    const [scaleData, setScaleData] = React.useState<Array<any>>([]);

    const data = useData();
    const db = data?.db?.collection('Riverlevel_data');
    const storage = data?.storage;

    const [modalOpen, setModalOpen] = React.useState(false);

    const handleModalClose = () => {
        setModalOpen(false)
        setRiverlevelReading(0.0)
        setDisableSubmit(false)
        clearUploadedFile()
    };

    const setAlert = (title: string, message: string, success = true) => {
        setAlertSuccess(success);
        setAlertMessage(message);
        setAlertMessageTitle(title);
        setOpenAlert(true);
    }

    useEffect(() => {
        data?.refreshRiverLevelData();
        // eslint-disable-next-line
    }, [])

    /*Get data from firebase and fill table*/
    useEffect(() => {
        setRiverlevelData(data?.riverLevelLogsData);
    }, [data?.riverLevelLogsData])

    useEffect(() => {
        setRiverlevelData(data?.riverLevelLogsData);
    }, [data?.riverLevelLogsData])

    useEffect(() => {
        if(data?.riverScaleData){
            setScaleData(data?.riverScaleData);
                if (data?.riverScaleData[0]) {
                    setLatitude(data?.riverScaleData[0].Latitude);
                    setLongitude(data?.riverScaleData[0].Longitude);
                    setAddress(data?.riverScaleData[0].Address);
                    setWatershedCode(data?.riverScaleData[0].WatershedCode);
                    setScaleName(data?.riverScaleData[0].Name);
                    setDisableFab(false);
                }
                else {
                    setDisableFab(true)
                    setAlert('No RiverScales','Please register a River Scale',false);
                }
        }
        else {
            setDisableFab(true);
        }
    }, [data?.riverScaleData])

    const handleClickAddButton = async () => {
        setModalOpen(true)
    }

    const addData = async () => {
        setDisableSubmit(true)
        //updateLocation();
        var Url = '';

        /*Upload image, if available*/
        try {
            if (storage) {
                if (image) {
                    const upload = await storage.ref('riverlevel/' + image.name).put(image);
                    if (upload) {
                        Url = await storage.ref('riverlevel').child(image.name).getDownloadURL();
                    }
                    else {
                        setAlert('Error', 'Image cannot be uploaded. Please try again.', false)
                        handleModalClose();
                        return;
                    }
                }
            } else {
                setAlert('Error', 'Image cannot be uploaded. Try again later!', false)
                handleModalClose();
                return;
            }
        }
        catch {
            setAlert('Error', 'Something went wrong!', false)
            handleModalClose();
            return;
        }

        try {
            const response = await db?.add({
                "Latitude": latitude,
                "Longitude": longitude,
                "Name": auth?.currentUser?.displayName,
                "Address": address,
                "WatershedCode": watershedCode,
                "Reading": Number(riverlevelReading).toFixed(2),
                "DateTime": selectedDateTime.getTime(),
                "Image": Url,
                "uid": auth?.currentUser?.uid,
                "timestamp": new Date().getTime(),
                "Status": 0,// (0)Pending | (1)Approved | (2)Rejected
            })
            if (response) {
                setAlert("Success!", 'Successfully logged data')
            }
            else {
                setAlert('Error', "Couldn't log data. Please try again.", false)
            }
        }
        catch {
            setAlert('Error', "Couldn't log data. Try again later!", false)
        }
        handleModalClose();
    }

    const deleteData = async () => {
        try {
            if (imageUrlToDelete) {
                if (storage) {
                    let imageRef = storage.refFromURL(imageUrlToDelete);
                    imageRef.delete();
                }
            }
            if (docToDelete) {
                await db?.doc(docToDelete).delete();
                setAlert('Deleted!', "Entry deleted successfully!")
            }
        }
        catch {
            setAlert('Error', "Couldn't delete entry. Try again later!", false)
        }
        deleteModalClose();
    }

    const clearUploadedFile = () => {
        setFileName('')
        setImage(undefined)
    }

    const handleTableClick = (DocImageUrl: GridCellValue) => {
        const imageUrl = DocImageUrl?.toLocaleString();
        if (imageUrl) {
            setModalImage(imageUrl);
            setOpenImageModal(true);
        }
    }

    const handleTableClickClose = () => {
        setOpenImageModal(false);
    }

    const deleteModalOpen = (docId: GridCellValue, docImageUrl: GridCellValue) => {
        const id = docId?.toLocaleString();
        const imageUrl = docImageUrl?.toLocaleString();
        if (id)
            setDocToDelete(id);
        if (imageUrl)
            setDeleteImageUrl(imageUrl);
        setDeleteModal(true);
    }

    const deleteModalClose = () => {
        setDeleteModal(false);
    }

    return (
        <Fragment>
            <Collapse in={openAlert}>
                <Alert
                    severity={alertSuccess ? "success" : "error"}
                    action={
                        <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                setOpenAlert(false);
                            }}
                        >
                            <CloseIcon fontSize="inherit" />
                        </IconButton>
                    }
                >
                    <AlertTitle>{alertMessageTitle}</AlertTitle>
                    {alertMessage}
                </Alert>
            </Collapse>
            <Grid container>
                {/* Chart 
                        <Grid item xs={12}>
                            <Paper className={fixedHeightPaper}>
                                <MyRainfallChart />
                            </Paper>
                        </Grid>
                        */}
                <Grid item xs={12}>
                    <Paper className={classes.paper} style={{ minHeight: '80vh' }}>
                        <Title>My Riverlevel Logs</Title>
                        <LogsTable data={riverlevelData} onImageDeleteClick={handleTableClick} onCellDeleteClick={deleteModalOpen} admin={false} />
                    </Paper>
                </Grid>
            </Grid>
            {!disableFab ?
                <Fab className={classes.fab} color="primary" aria-label="add" onClick={handleClickAddButton}>
                    <Add />
                </Fab> :
                <CircularProgress className={classes.fab} />
            }
            <div>
                <Dialog fullWidth open={modalOpen} onClose={handleModalClose} aria-labelledby="form-dialog-title" >
                    <DialogTitle id="form-dialog-title">
                        Log Riverlevel Data
                        <Button variant="text" style={{ float: 'right', padding: 0 }} onClick={handleModalClose}>
                            <HighlightOffOutlined />
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                        <FormControl>
                            <InputLabel htmlFor="outlined-role-native-simple">River Scale</InputLabel>
                            <Select
                                native
                                autoFocus
                                value={scaleName}
                                inputProps={{
                                    name: 'scale',
                                    id: 'outlined-role-native-simple',
                                }}
                                onChange={e => {
                                    const data = scaleData.find(item => item.GaugeId === e.target.value as String);
                                    setScaleName(e.target.value as string || '');
                                    setLatitude(Number(data.Latitude));
                                    setLongitude(Number(data.Longitude));
                                    setWatershedCode(data.WatershedCode);
                                    setAddress(data.Address);
                                }}
                                fullWidth
                            >
                                {scaleData.map((item) => {
                                    return <option key={item.GaugeId} value={item.GaugeId}>{item.Name}</option>
                                })}
                            </Select>
                        </FormControl>
                    </DialogContent>
                    <DialogContent>
                        <DialogContentText>
                            {(longitude !== 0.0 && latitude !== 0.0) &&
                                <span>
                                    GeoLocation: <b> {latitude + "," + longitude}</b>
                                </span>
                            }
                            <br />
                            {
                                (longitude !== 0.0 && latitude !== 0.0 && address) &&
                                <span>
                                    Address: <b>{address}</b>
                                </span>
                            }
                            <br />
                            {
                                (longitude !== 0.0 && latitude !== 0.0 && watershedCode) &&
                                <span>
                                    Watershed Code: <b>{watershedCode}</b>
                                </span>
                            }
                        </DialogContentText>
                    </DialogContent>
                    <DialogContent>
                        <DateTimePicker
                            label="Time of measurement"
                            inputVariant="outlined"
                            value={selectedDateTime}
                            onChange={(e: any) => {
                                setSelectedDateTime(e)
                                //console.log(gaugeData);
                            }}
                            fullWidth
                            disabled={!auth?.currentUserTrusted}
                        />
                    </DialogContent>
                    <DialogContent>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="measurement"
                            label="Riverlevel Measurement"
                            type="number"
                            inputProps={{ style: { textAlign: 'center' } }}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">cm</InputAdornment>,
                            }}
                            value={riverlevelReading}
                            onChange={(e: any) => {
                                const { value } = e.target;
                                var validNumber = new RegExp(/^\d*\.?\d*$/);
                                var lastValid = riverlevelReading;
                                if (validNumber.test(value))
                                    lastValid = value;
                                setRiverlevelReading(lastValid);
                            }}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogContent>
                        <Button
                            variant="outlined"
                            component="label"
                            color="primary"
                        >
                            Add photo
                            <input
                                accept="image/*"
                                type="file"
                                hidden
                                onChange={(e: any) => {
                                    if (e.target.files[0] != null) {
                                        const newFile = new File([e.target.files[0]], `${auth?.currentUser?.uid}_${new Date().getTime()}`, { type: e.target.files[0].type })
                                        setFileName(e.target.files[0].name);
                                        setImage(newFile);
                                    }
                                }}
                                required
                            />
                        </Button> {fileName}
                        {fileName && <IconButton
                            aria-label="delete"
                            color="inherit"
                            onClick={() => {
                                clearUploadedFile()
                            }}
                        >
                            <DeleteIcon />
                        </IconButton>}
                    </DialogContent>
                    {!auth?.currentUserTrusted && <Alert severity="info">Kindly note : <br />
                        1. Please log the measurement from the actual location of your river scale.<br />
                        2. Please log the measurement in real time.<br />
                        3. Please add a photo of your river scale showing the measurement you entered.</Alert>}
                    <DialogActions>
                        <Button onClick={handleModalClose} variant="outlined" color="default">
                            Cancel
                        </Button>
                        <Button onClick={() => { (riverlevelReading > 0) ? addData() : setConfirmationModal(true) }} variant="contained" color="primary" disabled={(!auth?.currentUserTrusted && !image) || disableSubmit}>
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <div>
                <Dialog open={openImageModal} onClose={handleTableClickClose} aria-labelledby="form-dialog-title"
                >
                    <DialogContent style={{ padding: 2 }}>
                        <img className={classes.imgFilled} src={modalImage} alt={"DataImage"} />
                    </DialogContent>
                </Dialog>
            </div>
            <div>
                <Dialog open={deleteModal} onClose={deleteModalClose} aria-labelledby="form-dialog-title">
                    <DialogContent>
                        Are you sure you want to delete this data?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={deleteModalClose} variant="contained" color="secondary">
                            Cancel
                        </Button>
                        <Button onClick={deleteData} variant="contained" color="primary">
                            Delete
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            <div>
                <Dialog open={confirmationModal} onClose={() => { setConfirmationModal(false) }} aria-labelledby="form-dialog-title">
                    <DialogContent>
                        Are you sure you want to log 'No Rainfall' in the last 24 hours?
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setConfirmationModal(false) }} variant="contained" color="secondary">
                            No
                        </Button>
                        <Button onClick={() => { setRiverlevelReading(0); addData(); setConfirmationModal(false) }} variant="contained" color="primary">
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </Fragment>
    );
}

export default UserRiverLevelLogs;